import { createSlice } from "@reduxjs/toolkit";

export const loginSlice = createSlice({
  name: "login",
  initialState: {
    isLoggedIn: false,  
    isLoading: false,
    isError: false,
    loginData: null,
    message: "",
    status_code: 0,
  },
  reducers: {
    onLoginUser: (state) => {
      return {
        ...state,
        isLoading: true,
        isError: false,
        loginData: null,
        message: "",
        status_code: 0,
      };
    },
    onLoginUserSuccess: (state, { payload }) => {
      const { data = null, message = "", status_code = 200 } = payload;
      return {
        ...state,
        isLoading: false,
        isError: false,
        loginData: data,
        message: message,
        status_code: status_code,
      };
    },
    onLoginUserError: (state, { payload }) => {
      const { data = null, message = "", status_code = 400 } = payload;
      return {
        ...state,
        isLoading: false,
        isError: true,
        loginData: data,
        message: message,
        status_code: status_code,
      };
    },
    onLoginUserReset: (state) => {
      return {
        ...state,
        isLoading: false,
        isError: false,
        isLoggedIn: false,
        message: "",
        status_code: 0,
      };
    },
    clearLoginData: (state) => {
      state.loginData = null;
    },
  },
});
export const { onLoginUser, onLoginUserSuccess, onLoginUserError, onLoginUserReset, clearLoginData } = loginSlice.actions;
export default loginSlice.reducer;